__turbopack_context__.v({
  "accountModalCompact": "global-modals-container-module-sass-module__tAtnlG__accountModalCompact",
  "betslipModal": "global-modals-container-module-sass-module__tAtnlG__betslipModal",
  "container": "global-modals-container-module-sass-module__tAtnlG__container",
  "game": "global-modals-container-module-sass-module__tAtnlG__game",
  "loginModalCompact": "global-modals-container-module-sass-module__tAtnlG__loginModalCompact",
  "multiWalletModal": "global-modals-container-module-sass-module__tAtnlG__multiWalletModal",
  "multiWalletProModal": "global-modals-container-module-sass-module__tAtnlG__multiWalletProModal",
  "walletButtonActive": "global-modals-container-module-sass-module__tAtnlG__walletButtonActive",
  "walletModal": "global-modals-container-module-sass-module__tAtnlG__walletModal",
  "walletModalContainer": "global-modals-container-module-sass-module__tAtnlG__walletModalContainer",
  "walletPixModal": "global-modals-container-module-sass-module__tAtnlG__walletPixModal",
  "walletTolaModal": "global-modals-container-module-sass-module__tAtnlG__walletTolaModal",
});
